/* eslint-disable */

import React, { useEffect, useState } from "react";

import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";

import { motion } from "framer-motion";
enum QuizAnswerButtonState {
  Correct = "correct",
  Incorrect = "incorrect",
  Neutral = "neutral",
}

const Pulse = () => {
  return (
    <motion.div
      animate={{
        scale: [1, 1.2],
        opacity: [0.3, 0],
        transition: {
          duration: 0.4,
        },
      }}
      className="flex h-full w-full bg-green-300 absolute rounded-xl"
    ></motion.div>
  );
};

const Magic = () => {
  return (
    <div className="flex h-full w-full absolute">
      <motion.div
        animate={{
          scale: [0.6, 1],
          translateY: [70, 40],
          translateX: [30, 32],
          opacity: [0, 0.2],
          transition: {
            duration: 0.3,
            type: "easeOut",
          },
        }}
        className="w-6 h-6   bg-color-border-green rounded-full"
      />
      <motion.div
        animate={{
          scale: [0.4, 1],
          translateY: [60, 20],
          translateX: [120, 126],
          opacity: [0, 0.1],
          transition: {
            duration: 0.3,
            type: "easeOut",
          },
        }}
        className="w-8 h-8   bg-color-border-green rounded-full"
      />
    </div>
  );
};

const QuizAnswerButton = ({
  onClick,
  title,
  isCorrectAnswer = true,
  highlightDuration = 150,
  isThin = false,
}) => {
  const [internalState, setInternalState] = useState<QuizAnswerButtonState>(
    QuizAnswerButtonState.Neutral
  );

  let bg = "bg-color-background-primary dark:bg-color-dark-background-primary";
  let border =
    "border-color-border-primary dark:border-color-dark-border-primary";

  let textColor = "text-color-text-primary dark:text-color-dark-text-primary";

  let tailwindHeight = "h-[100px]";

  if (isThin) {
    tailwindHeight = "h-[50px]";
  }

  if (internalState === QuizAnswerButtonState.Correct) {
    border = "border-color-border-green dark:border-color-dark-border-green";
    bg = "bg-color-background-green dark:bg-color-dark-background-green";
    textColor = "text-color-border-green dark:text-color-dark-border-green";
  }

  if (internalState === QuizAnswerButtonState.Incorrect) {
    border = "border-color-border-red dark:border-color-dark-border-red";
    bg = "bg-color-background-red dark:bg-color-dark-background-red";
    textColor = "text-color-border-red dark:text-color-dark-border-red";
  }

  const onClickInternal = () => {
    if (isCorrectAnswer) {
      setInternalState(QuizAnswerButtonState.Correct);
    } else {
      setInternalState(QuizAnswerButtonState.Incorrect);
    }
    onClick();
  };

  useEffect(() => {
    if (internalState === QuizAnswerButtonState.Neutral) {
      return;
    }

    const timeout = setTimeout(() => {
      setInternalState(QuizAnswerButtonState.Neutral);
    }, highlightDuration);

    return () => {
      clearTimeout(timeout);
    };
  }, [internalState]);

  let animate = {
    opacity: [0, 1],
  };

  if (internalState !== QuizAnswerButtonState.Neutral) {
    animate = {
      opacity: [1, 0],
    };
  }

  return (
    <motion.div animate={animate} className="flex flex-col relative">
      {internalState === QuizAnswerButtonState.Correct && <Pulse />}
      <RaindropClickable onClick={onClickInternal}>
        <div
          className={`flex flex-col w-[150px] ${tailwindHeight} p-2  rounded-lg border-4 text-center font-bold md:hover:opacity-90 gap-2 items-center justify-center  ${bg} ${border} ${textColor} transition-all`}
        >
          <h1 className="font-extrabold">{title}</h1>
        </div>
      </RaindropClickable>
      {internalState === QuizAnswerButtonState.Correct && <Magic />}
    </motion.div>
  );
};

export default QuizAnswerButton;
